// Remember which advert brought the visitor (utm_source / utm_campaign) for the whole visit.
const KEY = 'fbc_utm';

export const rememberUtm = () => {
  const q = new URLSearchParams(window.location.search);
  const src = q.get('utm_source');
  if (src) sessionStorage.setItem(KEY, JSON.stringify({ utm_source: src, utm_campaign: q.get('utm_campaign') || null }));
};

export const getUtm = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch { return {}; }
};
